import React, { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDebounceVariable } from 'modules/core/hooks';

import { Input, IInput } from '../Input/Input';
import { StyledInputWrapper } from './HighlightedInput.styles';

export const HighlightedInput: FC<IInput> = (props) => {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(props.name);
  const [isFocused, setIsFocused] = useState(false);

  const hasErrorField = props.name?.split('.').reduce((acc: any, key: string) => acc?.[key], errors);
  const hasErrorDebounce = useDebounceVariable(!!hasErrorField, 10);
  const hasError = isFocused ? hasErrorField : hasErrorDebounce;

  const isValueEmpty = value === undefined || value === null || value === '' || isNaN(value);

  const showGreenBorder = !hasError && !props.disabled && isValueEmpty;

  const showErrorBorder = !!hasError && !props.disabled;

  return (
    <StyledInputWrapper
      $showGreenBorder={showGreenBorder}
      $showError={showErrorBorder}
      $disabled={props.disabled}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <Input {...props} />
    </StyledInputWrapper>
  );
};
